import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import { ITierTypeModel, TierTypeModel } from './model/tierType.model';
const { model, maybeNull } = types;
export const ClientProgressStore = model('ClientProgressStore', {
  tierType: maybeNull(TierTypeModel),
})
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeTierType({ data }: AxiosResponse): ITierTypeModel | null {
      const tierTypeInstances = data.data.map((item: any) => TierTypeModel.create(item));
      self.tierType = tierTypeInstances[0];
      return self.tierType;
    },
  }))
  .actions((self) => ({
    getTierType: flow(function* () {
      const result = yield axios
        .get<ITierTypeModel>(`admin/getting-started`)
        .then(self.normalizeTierType)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    postEndRequest: flow(function* (data: string) {
      const result = yield axios
        .post(`admin/getting-started/add`, {
          module: data,
        })
        .then()
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IClientProgressStore = Instance<typeof ClientProgressStore>;
